'use client';

import { useState } from 'react';
import { PostCard } from './PostCard';
import type { BlogCardData } from './blog-shared';

/** Category chips (client-side filter over the posts on this page, as the live index does) + the card grid. */
export function BlogGridV2({ posts, basePath }: { posts: BlogCardData[]; basePath: string }) {
  const [cat, setCat] = useState<string | null>(null);
  const cats = Array.from(new Set(posts.map((p) => p.category).filter(Boolean))).sort();
  const shown = cat ? posts.filter((p) => p.category === cat) : posts;
  return (
    <>
      {cats.length > 1 && (
        <div className="bp-filter" role="group" aria-label="Filter by category">
          <button type="button" className="bp-fb" aria-pressed={cat === null} onClick={() => setCat(null)}>All</button>
          {cats.map((c) => (
            <button key={c} type="button" className="bp-fb" aria-pressed={cat === c} onClick={() => setCat(cat === c ? null : c)}>{c}</button>
          ))}
        </div>
      )}
      <div className="bp-grid-c">
        {shown.map((p) => <PostCard key={p.slug} post={p} basePath={basePath} />)}
      </div>
    </>
  );
}
